import React, { useContext } from 'react';
import { convertUndefinedFields } from 'utils/helpers';
import { ICreateFirmwareContext, CreateFirmwareContext } from '../createFirmwareState/createFirmwareContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { AppContext, IAppContext } from 'appState/appContext';
import { createFirmware } from 'backend/firmware';

export const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { resetFields, changeTypeOfModalWindow, dataForSubmit, typeOfModalWindow } =
		useContext<ICreateFirmwareContext>(CreateFirmwareContext);

	const handleSubmit = async () => {
		if (dataForSubmit) {
			try {
				const convertedData = convertUndefinedFields(dataForSubmit);
				showLoader();
				await createFirmware(convertedData);
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	};

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			<ModalToConfirm
				onConsentEvent={resetFields}
				onFailureEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'toConfirmFieldsClearing'}
				description="cancelSaveInfo"
			/>
			<ModalToConfirm
				onConsentEvent={handleSubmit}
				onFailureEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'toConfirmSubmit'}
				description="saveInfo"
			/>
			<ModalSentSuccessfully
				onConsentEvent={resetFields}
				isVisible={typeOfModalWindow === 'success'}
				description="savedSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSaving"
			/>
		</ModalWrapper>
	);
};
